export default {
  install(Vue, options) {
    const eventHandler = (context) => {
      // console.log(context, options, document.activeElement);
      const event = new Event('remote', {
        type: 'remote.a',
        bubbles: true,
      });
      document.activeElement.dispatchEvent(event);
    };
    document.addEventListener('keyup', eventHandler);
    window.addEventListener('message', eventHandler);

    Vue.directive('remote', {
      bind(e, binding, vnode) {
        var s = JSON.stringify;
        e.innerHTML =
          'name: ' +
          s(binding.name) +
          '<br>' +
          'value: ' +
          s(binding.value) +
          '<br>' +
          'expression: ' +
          s(binding.expression) +
          '<br>' +
          'argument: ' +
          s(binding.arg) +
          '<br>' +
          'modifiers: ' +
          s(binding.modifiers) +
          '<br>' +
          'vnode keys: ' +
          Object.keys(vnode).join(', ');
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/plugin/RemoteControl.js